import { appInfoReducer } from '../slices/appInfo/slice';
import { appInfoSliceName } from '../slices/appInfo/constants';
import { licenseReducer } from '../slices/license/slice';
import { fymAPI } from '../api/fymAPI';
import { musicAPI } from '../api/musicAPI';
import { licenseSliceName } from '../slices/license/constants';
import { alertSliceName } from '../slices/alerts/constants';
import { alertReducer } from '../slices/alerts/slice';
import { toastsSliceName } from '../slices/toasts/constants';
import { toastsReducer } from '../slices/toasts/slice';

export const rootReducer = {
  [appInfoSliceName]: appInfoReducer,
  [licenseSliceName]: licenseReducer,
  [fymAPI.reducerPath]: fymAPI.reducer,
  [musicAPI.reducerPath]: musicAPI.reducer,
  [alertSliceName]: alertReducer,
  [toastsSliceName]: toastsReducer,
};
